if (!window.OliversPickupAvailability) {
  window.OliversPickupAvailability = {
    zurichNow() {
      const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Zurich',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date());
      const value = type => Number(parts.find(part => part.type === type).value);
      const year = value('year');
      const month = value('month');
      const day = value('day');

      return {
        isoDate: `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`,
        hour: value('hour'),
        minute: value('minute')
      };
    },

    parseDate(value) {
      const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!match) return null;
      const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
      return Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== value ? null : date;
    },

    addDays(date, days) {
      const copy = new Date(date.getTime());
      copy.setUTCDate(copy.getUTCDate() + days);
      return copy;
    },

    toIso(date) {
      return date.toISOString().slice(0, 10);
    },

    isoWeekday(date) {
      return date.getUTCDay() === 0 ? 7 : date.getUTCDay();
    },

    weekdayNumber(day) {
      return {
        Montag: 1,
        Dienstag: 2,
        Mittwoch: 3,
        Donnerstag: 4,
        Freitag: 5,
        Samstag: 6,
        Sonntag: 7
      }[day];
    },

    availableDates(location, options = {}) {
      const limit = Math.max(1, Number(options.limit || 100));
      const searchDays = Math.max(0, Number(options.searchDays || 60));
      const now = this.zurichNow();
      const today = this.parseDate(now.isoDate);
      const horizonEnd = this.addDays(today, searchDays);
      const weekdays = (location.weekdays || []).map(day => this.weekdayNumber(day)).filter(Boolean);
      const blockedDates = new Set(location.blockedDates || []);
      const from = location.availableFrom ? this.parseDate(location.availableFrom) : null;
      const until = location.availableUntil ? this.parseDate(location.availableUntil) : null;
      const specificDates = Array.isArray(location.specificDates) ? location.specificDates : [];
      const cutoffDays = Math.max(0, Number(location.cutoffDaysBefore || 0));
      const cutoffMatch = String(location.cutoffTime || '').match(/^(\d{2}):(\d{2})/);
      const cutoffHour = cutoffMatch && Number(cutoffMatch[1]) <= 23 ? Number(cutoffMatch[1]) : 23;
      const cutoffMinute = cutoffMatch && Number(cutoffMatch[2]) <= 59 ? Number(cutoffMatch[2]) : 59;
      const dates = [];

      const isPastCutoff = (candidateIso) => {
        const candidate = this.parseDate(candidateIso);
        if (!candidate) return true;
        const cutoffDate = this.addDays(candidate, -cutoffDays);
        const cutoffIso = this.toIso(cutoffDate);
        const cutoffMinutes = cutoffHour * 60 + cutoffMinute;
        const currentMinutes = now.hour * 60 + now.minute;
        return now.isoDate > cutoffIso || (now.isoDate === cutoffIso && currentMinutes >= cutoffMinutes);
      };

      if (specificDates.length > 0) {
        specificDates.forEach(dateStr => {
          const date = this.parseDate(dateStr);
          if (!date || blockedDates.has(dateStr)) return;
          if (from && date < from) return;
          if (until && date > until) return;
          if (date > horizonEnd) return;
          if (!isPastCutoff(dateStr)) {
            dates.push(dateStr);
          }
        });
        dates.sort();
        return dates.slice(0, limit);
      }

      for (let offset = 0; offset <= searchDays && dates.length < limit; offset += 1) {
        const candidate = this.addDays(today, offset);
        const iso = this.toIso(candidate);
        if (from && candidate < from) continue;
        if (until && candidate > until) continue;
        if (!weekdays.includes(this.isoWeekday(candidate))) continue;
        if (blockedDates.has(iso)) continue;
        if (isPastCutoff(iso)) continue;

        dates.push(iso);
      }

      return dates;
    },

    formatDate(value, options = {}) {
      const date = this.parseDate(value);
      if (!date) return String(value || '');
      const includeYear = options.includeYear !== false;
      return new Intl.DateTimeFormat(document.documentElement.lang || 'de-CH', {
        timeZone: 'UTC',
        weekday: 'long',
        day: '2-digit',
        month: '2-digit',
        ...(includeYear ? { year: 'numeric' } : {})
      }).format(date);
    },

    formatCompactDate(value) {
      const date = this.parseDate(value);
      if (!date) return String(value || '');
      const parts = new Intl.DateTimeFormat(document.documentElement.lang || 'de-CH', {
        timeZone: 'UTC',
        weekday: 'short',
        day: 'numeric',
        month: 'short'
      }).formatToParts(date);
      const part = type => (parts.find(item => item.type === type)?.value || '').replace(/[.,]/g, '');

      return `${part('weekday')} ${part('day')}. ${part('month')}`.trim();
    }
  };
}
